// HTTP error status
export const DEFAULT_ERROR_STATUS = 400;
export const UNAUTHORIZED_ERROR_STATUS = 401;

// error codes
export const REFRESH_ERROR_CODE = 'TMx00000019';

// errors
export const REFRESH_ERROR = 'REFRESH';
